import type { IconData } from '@stacksjs/iconify-core'

export const userFaceMale: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M45 24c0 11.598-9.402 21-21 21S3 35.598 3 24S12.402 3 24 3s21 9.402 21 21\"/><path d=\"M23.906 3C22.9 13.629 13.974 21.951 3.094 21.999m41.812 0C34.026 21.95 25.099 13.629 24.094 3M16 24v2m16-2v2m-1 8c-3.062 4-10.937 4-14 0\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default userFaceMale
